import { render, staticRenderFns } from "./related-label.vue?vue&type=template&id=24da6f0e&"
import script from "./related-label.vue?vue&type=script&lang=js&"
export * from "./related-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports